// Persisted region preferences. Mirrors the pattern used by audioSettings,
// graphicsSettings, controlsSettings — direct localStorage with a games:
// prefix. Two keys:
//   games:serverRegion     — the user's preferred region id (string).
//   games:regionPingHints  — last-known region ping map (id → ms), used to
//                            seed the region picker before the first
//                            live probe completes on cold boot.

const STORAGE_KEY_PREF = 'games:serverRegion';
const STORAGE_KEY_HINTS = 'games:regionPingHints';

export function loadPreferredRegion(): string | null {
  try {
    const v = localStorage.getItem(STORAGE_KEY_PREF);
    return v && v.length > 0 ? v : null;
  } catch { return null; }
}

export function savePreferredRegion(regionId: string): void {
  try { localStorage.setItem(STORAGE_KEY_PREF, regionId); } catch { /* storage blocked */ }
}

export type RegionPingHints = Record<string, number>;

export function loadRegionPingHints(): RegionPingHints {
  try {
    const raw = localStorage.getItem(STORAGE_KEY_HINTS);
    if (!raw) return {};
    const parsed = JSON.parse(raw) as unknown;
    if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
      const out: RegionPingHints = {};
      for (const [k, v] of Object.entries(parsed)) {
        if (typeof v === 'number' && Number.isFinite(v) && v >= 0) out[k] = v;
      }
      return out;
    }
  } catch { /* bad JSON or storage blocked */ }
  return {};
}

export function saveRegionPingHints(hints: RegionPingHints): void {
  try { localStorage.setItem(STORAGE_KEY_HINTS, JSON.stringify(hints)); } catch { /* storage blocked */ }
}
